export const api = "https://api.buymenow.net/";
